module.exports = __webpack_public_path__ + "static/media/stakeLightActive.7cd07808.svg";